import { render, staticRenderFns } from "./recuperacao.vue?vue&type=template&id=7407742e"
import script from "./recuperacao.vue?vue&type=script&lang=js"
export * from "./recuperacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports